import { request } from 'sonata-react-components';

type Token = Record<string, any>;

/**
 * Fetches all optimization models for the given campaign countries.
 */
export function fetchOptimizationModels(
  optimizationModelCountries: string[],
  token: Token
): Promise<Record<string, any>[]> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}optimization-models`,
    {
      method: 'GET',
      params: {
        allVersions: 'true',
        country: optimizationModelCountries.join(','),
        status: 'approved'
      }
    },
    token
  );
}

/**
 * Fetches a single optimization model by id and version.
 */
export function fetchOptimizationModel(
  optimizationModelId: string,
  optimizationModelVersion: number | undefined,
  token: Token
): Promise<Record<string, any>> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}optimization-models/${optimizationModelId}`,
    {
      method: 'GET',
      params: {
        version: optimizationModelVersion
      }
    },
    token
  );
}

/**
 * Fetches the KPI catalog used to populate the KPI category selector.
 */
export function fetchOptimizationModelKpiCatalog(token: Token): Promise<Record<string, any>[]> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}resources/optimizationModelKpiCatalog`,
    {
      method: 'GET'
    },
    token
  );
}
